import { Link } from 'react-router-dom'

const formatMoney = value => {
	const number = Number(value)
	if (!Number.isFinite(number)) return '0'
	return number.toLocaleString('pl-PL', { minimumFractionDigits: 0, maximumFractionDigits: 2 })
}

export default function RozliczeniaTrainersTableRow({ trainer }) {
	const trainerId = trainer?._id || trainer?.id
	const unsettledMonths = Number(trainer?.unsettledMonths) || 0
	const doRozliczenia = Number(trainer?.do_rozliczenia) || 0

	return (
		<tr className="hover:bg-gray-100">
			<td className="py-3 px-4 border-b border-gray-200">
				<Link
					to={`/ksiegowosc/rozliczenia/${trainerId}`}
					className="font-medium text-blue-600 hover:text-blue-800 hover:underline transition-colors duration-200"
				>
					{trainer?.nazwa || '—'}
				</Link>
			</td>
			<td className="py-3 px-4 border-b border-gray-200 text-center text-gray-900">
				{unsettledMonths}
			</td>
			<td className="py-3 px-4 border-b border-gray-200 text-right font-medium text-gray-900">
				{formatMoney(doRozliczenia)} PLN
			</td>
		</tr>
	)
}
